export const DB_URL = process.env.NEXT_PUBLIC_DB_URL;
